import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { intersection, keys } from 'ramda'
import Select from 'react-select-plus'
import Icon from 'svg-inline-react'
import StatusAvatar from 'components/shared/AgentStatusAvatar'
import { Modal, Tag } from '@driftt/tide-core-legacy'
import * as RulesSelectors from 'app/modules/rules/selectors'
import * as RulesActions from 'app/modules/rules/actions'

import { api } from 'app/modules/rules/api'

import './style.styl'
import CLOSE_ICON from '!svg-inline?removeTags=true!images/icons/times-icon.svg'


class OnCallModal extends Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedParticipants: props.onCall.userIds
    }
  }

  componentDidMount() {
    this.props.actions.fetchRoundRobinByKey({ roundRobinKey: 'lastOnCall' })
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.onCall.userIds, this.props.onCall.userIds)) {
      this.setState({ selectedParticipants: nextProps.onCall.userIds })
    }
  }

  isDirty = () => !_.isEqual(this.props.onCall.userIds, this.state.selectedParticipants)

  saveOnCall = () => {
    const data = { userIds: this.state.selectedParticipants }

    api.editOncall(data)
    .then(()=> {
      this.props.fetchRules()
      this.props.onClose()
    })
    .catch(() => this.props.notifications.error("Something went wrong saving the participants."))
  }

  saveParticipant = (values) => {
    this.setState((prevState)=>{
      const newOptions = prevState.selectedParticipants.slice(0)
      const onlyValues = values.map((option) => option.value)
      newOptions.push(...onlyValues)
      newOptions.sort()

      return {
        selectedParticipants: newOptions
      }
    })
  }

  removeParticipant = (value) => {
    this.setState((prevState) => {
      return {
        selectedParticipants: _.without(prevState.selectedParticipants, value)
      }
    })
  }


  getFormattedUsersOptions() {
    const { users } = this.props
    const { selectedParticipants } = this.state
    const unusedUserIds = _.without(Object.keys(users).map(Number), ...selectedParticipants)

    return unusedUserIds
      .filter(userId => users[userId].status === 'ENABLED')
      .map((userId) => {
        const nameOrEmail = !!users[userId].name ? users[userId].name : users[userId].email
        return { label: nameOrEmail, value: userId }
      })
  }

  renderSearchBar() {
    const selectOptions = {
      multi: true,
      autoFocus: false,
      options: this.getFormattedUsersOptions(),
      onChange: this.saveParticipant,
      pageSize: 3,
      placeholder: 'Add a participant...'
    }

    return (
      <Select {...selectOptions} />
    )
  }


  renderParticipantSelectionList() {
    const lastOnCall = this.props.lastOnCall
    // TODO: loading state
    if (!lastOnCall) return null
    const activeParticipantIds = intersection(keys(this.props.users), this.state.selectedParticipants.map(String))
    const sortedParticipantIds = activeParticipantIds.sort((a,b) => a - b)
    const nextUpIndex = (sortedParticipantIds.findIndex(participantId => participantId === String(lastOnCall.lastRouted)) + 1) % sortedParticipantIds.length


    return (
      <ul style={{ height: `${(activeParticipantIds.length * 75) + 75 }px` }} >
        {
          sortedParticipantIds.map((userId, index) => {
            const nameOrEmail = user => user.name ? user.name : user.email
            const shouldShowName = !!this.props.users[userId] ? nameOrEmail(this.props.users[userId]) : '[Deleted User]'

            return (
              <li key={`${userId}-${index}`} className="participants-list-item">
                <StatusAvatar user={this.props.users[userId]} />
                <span>{shouldShowName}</span>
                {index === nextUpIndex && <Tag text="Next Up"></Tag>}
                <Icon src={CLOSE_ICON} className="remove" onClick={ () => this.removeParticipant(Number(userId)) }></Icon>
                </li>
            )
          })
        }
      </ul>
    )
  }

  render() {
    const { onClose } = this.props
    return (
      <Modal
        onClose={onClose}
        open={true}
        size="small"
      >
        <div className="drift-modal oncall-modal">
          <div className="oncall-modal-header">
            <h2>Default Rule</h2>
            <p>When teammates become a part of this rule, one participant will be added on a rotating basis</p>
          </div>
          <div className="drift-form">
            <div className="rules-choice-options oncall-participant-search">
              {this.renderSearchBar()}
            </div>

            <div className="rules-choice-selection oncall-participant-list">
              { this.renderParticipantSelectionList() }
            </div>
          </div>

          {this.isDirty() &&
            <footer>
              <button className="drift-button" onClick={onClose}>Cancel</button>
              <button className="drift-button drift-button-primary" onClick={this.saveOnCall}>Save</button>
            </footer>
          }

        </div>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchRoundRobinByKey: RulesActions.fetchRoundRobinByKey,
    },
      dispatch
  ),
})


const onCallModalMapStateToProps = (state) => {
  return {
    lastOnCall: RulesSelectors.getRoundRobinData(state, 'lastOnCall'),
  }
}

export default connect(onCallModalMapStateToProps, mapDispatchToProps)(OnCallModal)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/layouts/OnCallModal/index.js